import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash";

@Pipe({
  name: 'rubsfilter'
})
export class RubsfilterPipe implements PipeTransform {

  constructor() { }

  transform(value: any,): any {
    if (!value || !Array.isArray(value)) {
      return [];
    }
    return value.filter((rub: any) => {
      return rub.id === 'all' || (rub.products && rub.products.length > 0);
    });
  }
}
